import React, { Component } from 'react';
import { connect } from 'react-redux';
import {InputText} from 'primereact/inputtext';
import {Button} from 'primereact/button';
import {Panel} from 'primereact/panel';
import {Dropdown} from 'primereact/dropdown';
import {Calendar} from 'primereact/calendar';
import {InputSwitch} from 'primereact/inputswitch';
import FooterButton from '../../../shared/UI/FooterButton/FooterButton';    
import moment from 'moment';
import {Toast} from 'primereact/toast';
import Messages from '../../../shared/UI/Messages/Messages';

import {  DROPDOWN_CONFIG, COSTCENTER_ID,DAILY_SHIFT_SUBMENU_ID } from '../../../shared/Config';
import { HASACCESS, TIME_DURATION, REDIRECT_TO_URL } from '../../../shared/utility';
import * as actions from '../../../store/actions/index';

class AddCostCenter extends Component {
    state = {
        type: '',
        costcenternum: '',
        desc: '',
        // CostCenterLongdescription: '',
        // CostCenterSapCode: '',
        glaccount: '',
        orgunit: '',
        id: null,
    }


    componentDidMount(){       
        
        
        this.props.getMasterTableList('GetCostCenter');   

        this.getAccess = HASACCESS(COSTCENTER_ID);

         if (this.props.GetOrgUnit.length === 0 && this.props.getMasterKeywordList) {
            this.props.getMasterKeywordList('OrgUnit');
        }
        let type = this.props.match.params.type;
        if(type !== 'add'){
            setTimeout(() => {
                this.fetchSingleProcess();
            },1000)
        }
        
    }


    fetchSingleProcess = () => {
        
        let id = this.props.match.params.id;
        let type = this.props.match.params.type;
       let storageItems = [];
        
        if(this.props.tableLists && this.props.tableLists.length > 0) {
            storageItems = this.props.tableLists;
        }
        
        if (storageItems) {
            let filterData = storageItems.find(list => String(list.costcenterid) === String(id));
            if (filterData) {
                this.setState({
                    type: type,
                    costcenterid: filterData.costcenterid,
                    id: filterData.id,
                    costcenternum: filterData.costcenternum || '',
                    desc: filterData.desc || '',
                    // CostCenterLongdescription: filterData.CostCenterLongdescription || '',
                    glaccount: filterData.glaccount || '',
                    // CostCenterSapCode: filterData.CostCenterSapCode || '',
                    orgunit: filterData.orgunit || ''
                });
            }
        }
    }


    actionTemplate = (rowData, column) => {
        let rowIndex = column.rowIndex;
        return <div>
            <Button type="button" icon="pi pi-trash" className="p-button-danger" onClick={() => this.removeField(rowIndex)} ></Button>
        </div>;
    }

  
    add = () => {
            if (this.state.costcenternum.trim() === "") {
        this.growl.show({severity: 'error', summary: null, detail: 'Cost Center No. is required'});
        return;
    } else if (this.state.desc.trim() === "") {
        this.growl.show({severity: 'error', summary: null, detail: 'Short Description is required'});
        return;
    // } 
    // else if (this.state.CostCenterLongdescription.trim() === "") {
    //     this.growl.show({severity: 'error', summary: null, detail: 'Long Description is required'});
    //     return;
    // } else if (this.state.CostCenterSapCode.trim() === "") {
    //     this.growl.show({severity: 'error', summary: null, detail: 'SAP Code is required'});
    //     return;
    } else if (this.state.glaccount.trim() === "") {
        this.growl.show({severity: 'error', summary: null, detail: 'GL Account is required'});
        return;
    } else if (this.state.orgunit.trim() === "") {
        this.growl.show({severity: 'error', summary: null, detail: 'Org Unit is required'});
        return;
    }

        const data = {
            desc: this.state.desc,
            orgunit: this.state.orgunit,
            costcenternum: this.state.costcenternum,
            glaccount: this.state.glaccount,
            // CostCenterLongdescription: this.state.CostCenterLongdescription,
            // CostCenterSapCode: this.state.CostCenterSapCode,
            // id: this.state.id
        };

        if(this.state.type === 'edit'){
            data.costcenterid = this.state.costcenterid;
            data.costcenternum = this.state.costcenternum;
        }
        
        this.props.processDynamicData('CostCenter', this.state.type, data,'GetCostCenter');
    }

    resetData = () => {
                this.setState({type:'add',
                costcenternum: '',
                desc: '',
                // CostCenterLongdescription: '',
                glaccount: '',
                // CostCenterSapCode: '',
                orgunit: '',
                id: null
            });


    }

//     deleteCostCenter = () => {
//     if(window.confirm("Are you sure you want to delete this Cost Center?")) {
//         const id = this.state.id;
//         this.props.processDynamicData('CostCenter', 'delete', { id }, 'GetCostCenter');
//     }
// }


    
    onEditorValueChange = (props, value) => {
        let updatedValue = [...props.value];
        updatedValue[props.rowIndex][props.field] = value;
        this.setState({documentDetails: updatedValue});
    }

    inputTextEditor = (props, field) => {
        return <InputText type="text" value={props.rowData[field]} onChange={(e) => this.onEditorValueChange(props, e.target.value)} />;
    }


    removeField  = (removeIndex) => {

        const updatedDeptValue = this.state.rows.filter((value,index) => {
            return removeIndex !== index;
        })
        this.setState({rows:updatedDeptValue})

    }

    change = (e) => {
        let {name, value} = e.target;
        this.setState({[name]:value,touch:true})

        // setTimeout(() => {
        //     this.checkDuration();
        // },2000)
        
        
    }

    // checkDuration = () => {
    //     if(this.state.LunchStart !=='' && this.state.LunchEnd !==''){
    //         let LunchStart = new moment(this.state.LunchStart);
    //         LunchStart = LunchStart.format("HH:mm");
    //         let LunchEnd = new moment(this.state.LunchEnd);
    //         LunchEnd = LunchEnd.format("HH:mm");
    //         let LunchDuration = TIME_DURATION(LunchStart,LunchEnd);
    //         let checkTst = LunchDuration.split(':');
    //         if(checkTst[0] < 0  && checkTst[1] < 0){
    //             this.growl.show({severity: 'error', summary: null, detail: 'Lunch duration should be positive digits'});  
    //         }else{
    //             this.setState({LunchDuration:LunchDuration})
    //         }
    //     }
    // }


    render() {   


        if(this.props.success){
            REDIRECT_TO_URL('/CostCenter',this.props);
        }
        const type = this.props.match.params.type;
    const isViewMode = type === 'view';

        let addAccess = true;
        let editAccess = true;
        if(this.getAccess!==undefined){
            if(this.getAccess.viewAccess === false){this.props.history.push('/dashboard')}
            addAccess = (this.getAccess.addAccess === true) ? true : false;
            editAccess = (this.getAccess.editAccess === true) ? true : false;
        }
        let accessButton = { addAccess : addAccess, editAccess : editAccess}

//        let isEnabled = (
//     this.state.costcenternum.trim() !== '' &&
//     this.state.desc.trim() !== '' &&
//     this.state.CostCenterLongdescription.trim() !== '' &&
//     this.state.glaccount.trim() !== '' &&
//     this.state.CostCenterSapCode.trim() !== '' &&
//     this.state.orgunit.trim() !== ''
// );

        return (
            <div className="p-grid ">
                { this.props.loading && <div className="page-loader"></div>}
                { this.props.error !== null && <Messages type="error" message={this.props.error}/>}
                { this.props.success !== null && <Messages type="success" message={this.props.success}/>}
                <Toast ref={(el) => this.growl = el} />
                <div className="p-col-12">
                    <div className="card card-w-title" style={{position:'relative'}}>
                        <h1>Add Cost Center</h1>
           
                        <div className="p-grid mt2">
                            <div className="p-col-12 p-md-6 p-lg-6">
                                <label className="label">Cost Center No. <span className="requiredColor">*</span></label>
                                <div className="mt1">
                                    <InputText className="p-col-12" name="costcenternum" value={this.state.costcenternum} placeholder="Cost Center No." onChange={this.change} />
                                </div>
                            </div>
                            <div className="p-col-12 p-md-6 p-lg-6">
                                <label className="label">Description <span className="requiredColor">*</span></label>
                                <div className="mt1">
                                    <InputText className="p-col-12" name="desc" value={this.state.desc} placeholder="Description" onChange={this.change} />
                                </div>
                            </div>
                            {/* <div className="p-col-12 p-md-6 p-lg-6">
                                <label className="label">Long Description <span className="requiredColor">*</span></label>
                                <div className="mt1">
                                    <InputText className="p-col-12" name="CostCenterLongdescription" value={this.state.CostCenterLongdescription} placeholder="Long Description" onChange={this.change} />
                                </div>
                            </div> */}
                            <div className="p-col-12 p-md-6 p-lg-6">
                                <label className="label">Cost Element (GL Account) <span className="requiredColor">*</span></label>
                                <div className="mt1">
                                    <InputText className="p-col-12" name="glaccount" value={this.state.glaccount} placeholder="GL Account" onChange={this.change} />
                                </div>
                            </div>
                            {/* <div className="p-col-12 p-md-6 p-lg-6">
                                <label className="label">SAP Code <span className="requiredColor">*</span></label>
                                <div className="mt1">
                                    <InputText className="p-col-12" name="CostCenterSapCode" value={this.state.CostCenterSapCode} placeholder="SAP Code" onChange={this.change} />
                                </div>
                            </div> */}
                            <div className="p-col-12 p-md-6 p-lg-6">
                                <label className="label">Org Unit <span className="requiredColor">*</span></label>
                                <div className="mt1">
                                    {/* <InputText className="p-col-12" name="" value={this.state.orgunit} placeholder="Org Unit" onChange={this.change} /> */}
                                    <Dropdown placeholder="Select Org Unit" name="orgunit" value={this.state.orgunit} options={this.props.GetOrgUnit} onChange={this.change} className="p-col-12"  {...DROPDOWN_CONFIG}/>
                                    
                                </div>
                            </div>
                            <div className="p-col-12 p-lg-12">
                                <FooterButton access={accessButton} type={this.state.type.toLowerCase()} save={this.add} reset={this.resetData}  to={"/CostCenter"} />
                                {/* <FooterButton access={accessButton} type={this.state.type.toLowerCase()} save={this.add} reset={this.resetData}  to={"/CostCenter"} /> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}


const mapStateToProps = state => {
    return{
        loggedUserDetail : state.auth.userObject,
        userDetail : state.auth.userDetail,
        userPref : state.auth.userPref,
        loading : state.master.loading,
        error : state.master.error,
        success : state.master.success,
        tableLists : state.master.tableLists,
        GetOrgUnit : (state.keyword.OrgUnit!==undefined) ? state.keyword.OrgUnit : [],
    }
}

const mapDispatchToProps = dispatch => {
    return {
        processDynamicData: (model,type,data,func) => dispatch(actions.processDynamicData(model,type,data,func)),
        getMasterTableList: (table) => dispatch(actions.getMasterTableList(table)),
        getMasterKeywordList: (keyword) => dispatch(actions.getMasterKeywordList(keyword)), // <-- Added line        
    }
}
  
export default connect(mapStateToProps,mapDispatchToProps)(AddCostCenter);